module.exports = __webpack_public_path__ + "stay-nights.png?470d85a0adeea05b00debf4617df867d";